import { LanguageCode } from "@/shared/types"

const FLAG_CDN_BASE = "https://cdn.jsdelivr.net/npm/flag-icons@7.5.0/flags/4x3"

type FlagSource = {
  file: string
  alt: string
  isLocal?: boolean
}

const FLAG_SOURCES: Record<LanguageCode, FlagSource> = {
  en: { file: "gb.svg", alt: "United Kingdom" },
  ar: { file: "arab.svg", alt: "Arabic language" },
  de: { file: "de.svg", alt: "Germany" },
  es: { file: "es.svg", alt: "Spain" },
  fa: {
    file: "/assets/flags/naval-ensign-iran.svg",
    alt: "Iran (Naval Ensign 1907-1933)",
    isLocal: true
  },
  hi: { file: "in.svg", alt: "India" },
  kk: { file: "kz.svg", alt: "Kazakhstan" },
  pl: { file: "pl.svg", alt: "Poland" },
  ru: { file: "ru.svg", alt: "Russia" },
  uk: { file: "ua.svg", alt: "Ukraine" },
  uz: { file: "uz.svg", alt: "Uzbekistan" },
  zh: { file: "cn.svg", alt: "China" }
}

interface FlagIconProps extends Omit<React.ComponentProps<"img">, "src"> {
  // Accepts any string: i18n.language can be a regional tag like "en-US" that
  // is not a LanguageCode, so we fall back to the English flag at runtime.
  code: string
}

const isLanguageCode = (value: string): value is LanguageCode => value in FLAG_SOURCES

export const LanguageFlag: React.FC<FlagIconProps> = ({ code, alt, title, ...props }) => {
  const assets = isLanguageCode(code) ? FLAG_SOURCES[code] : FLAG_SOURCES.en
  const src = assets.isLocal ? assets.file : `${FLAG_CDN_BASE}/${assets.file}`

  return (
    <img
      width={32}
      height={24}
      loading="lazy"
      decoding="async"
      {...props}
      src={src}
      title={title}
      alt={alt ?? title ?? assets.alt}
    />
  )
}
